import { useRef } from "react";
import WeekRow from "./WeekRow";
import DayRow from "./DayRow";
import DataRows from "./DataRows";
import BottomTotal from "./BottomTotal";
import { Tooltip } from "../../tooltip/Tooltip";
import PropTypes from "prop-types";

const ReportingTable = ({
  stats,
  sortOrder,
  setSortOrder,
  setSlaveDataType,
  splitBy,
  projects = [],
  slaveDataType,
}) => {
  const tooltipRef = useRef(null);

  return (
    <div className="reporting__table-wrapper">
      <div className="reporting__table-content">
        <table className="main-reporting-table">
          <WeekRow
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            setSlaveDataType={setSlaveDataType}
            splitBy={splitBy}
            slaveDataType={slaveDataType}
            stats={stats}
          />

          <DayRow stats={stats} />

          <DataRows
            stats={stats}
            splitBy={splitBy}
            projects={projects}
            slaveDataType={slaveDataType}
            tooltipRef={tooltipRef}
          />

          <Tooltip ref={tooltipRef} />

          <BottomTotal stats={stats} />
        </table>
      </div>
    </div>
  );
};

ReportingTable.propTypes = {
  stats: PropTypes.object.isRequired,
  sortOrder: PropTypes.string.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  setSlaveDataType: PropTypes.func.isRequired,
  splitBy: PropTypes.string.isRequired,
  projects: PropTypes.array.isRequired,
  slaveDataType: PropTypes.string.isRequired,
};

export default ReportingTable;
